import { ref, onMounted, onBeforeUnmount, readonly } from 'vue'

const MOBILE_MAX = 767
const TABLET_MAX = 1023

// width · isTablet 도 내보냈지만 쓰는 곳이 없었다. width 는 브레이크포인트를 넘을 때만 갱신돼서
// 실제 폭과 어긋난 값이기도 했다 — 쓰는 사람이 생기기 전에 걷어낸다.
const state = {
  isMobile: ref(false),
  isDesktop: ref(true),
  refCount: 0,
  mqMobile: null,
  mqTablet: null
}

function sync() {
  if (typeof window === 'undefined') return
  const w = window.innerWidth
  state.isMobile.value = w <= MOBILE_MAX
  state.isDesktop.value = w > TABLET_MAX
}

function attach() {
  if (typeof window === 'undefined') return
  if (state.refCount === 0) {
    state.mqMobile = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`)
    state.mqTablet = window.matchMedia(
      `(min-width: ${MOBILE_MAX + 1}px) and (max-width: ${TABLET_MAX}px)`
    )
    state.mqMobile.addEventListener('change', sync)
    state.mqTablet.addEventListener('change', sync)
    sync()
  }
  state.refCount += 1
}

function detach() {
  state.refCount -= 1
  if (state.refCount <= 0) {
    state.refCount = 0
    if (state.mqMobile) state.mqMobile.removeEventListener('change', sync)
    if (state.mqTablet) state.mqTablet.removeEventListener('change', sync)
    state.mqMobile = null
    state.mqTablet = null
  }
}

export function useBreakpoint() {
  onMounted(attach)
  onBeforeUnmount(detach)

  if (typeof window !== 'undefined' && state.refCount === 0) {
    sync()
  }

  return {
    isMobile: readonly(state.isMobile),
    isDesktop: readonly(state.isDesktop)
  }
}
